import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LmsMenu.css';

function LmsMenu({ activeSection, onSectionChange }) {
  const navigate = useNavigate();
  const userName = localStorage.getItem('userName') || 'Student Name';
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = () => {
    setShowLogoutConfirm(true);
  };

  const confirmLogout = () => {
    setIsLoggingOut(true);
    // Clear user data from localStorage
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userName');
    
    // Add a slight delay for better UX
    setTimeout(() => {
      navigate('/login');
    }, 500);
  };

  const cancelLogout = () => {
    setShowLogoutConfirm(false);
  };
  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: '📊', enabled: true },
    { id: 'my-workshops', label: 'My Workshops', icon: '🧩', enabled: true },
    { id: 'courses', label: 'My Courses', icon: '📚', enabled: false },
    { id: 'catalog', label: 'Course Catalog', icon: '🔍', enabled: false },
    // { id: 'progress', label: 'Progress', icon: '📈', enabled: false },
    // { id: 'certificates', label: 'Certificates', icon: '🎓', enabled: false },
    // { id: 'assignments', label: 'Assignments', icon: '📝', enabled: false },
    // { id: 'calendar', label: 'Calendar', icon: '📅', enabled: false },
    // { id: 'resources', label: 'Resources', icon: '📁', enabled: false },
     { id: 'settings', label: 'Settings', icon: '⚙️', enabled: true }
  ];

  return (
    <div className="lms-sidebar">
    
      
      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          <button
            key={item.id}
            className={`nav-item ${activeSection === item.id ? 'active' : ''} ${!item.enabled ? 'disabled' : ''}`}
            onClick={() => {
              if (!item.enabled) return;
              onSectionChange(item.id);
            }}
            disabled={!item.enabled}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
            {!item.enabled && <span className="coming-soon-badge">Soon</span>}
          </button>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="user-info">
          <div className="user-avatar">👤</div>
          <div className="user-details">
            <p className="user-name">{userName}</p>
            <p className="user-role">Learner</p>
          </div>
        </div>
        <button 
          className={`logout-btn ${isLoggingOut ? 'logging-out' : ''}`} 
          onClick={handleLogout}
          disabled={isLoggingOut}
        >
          <span className="logout-icon">{isLoggingOut ? '⏳' : '🚪'}</span>
          <span>{isLoggingOut ? 'Logging out...' : 'Logout'}</span>
        </button>
      </div>

      {showLogoutConfirm && (
        <div className="logout-modal-overlay" onClick={cancelLogout}>
          <div className="logout-modal" onClick={(e) => e.stopPropagation()}>
            <div className="logout-modal-header">
              <span className="logout-modal-icon">⚠️</span>
              <h3>Confirm Logout</h3>
            </div>
            <div className="logout-modal-body">
              <p>Are you sure you want to logout?</p>
              <p className="logout-modal-subtitle">You'll need to sign in again to access your courses.</p>
            </div>
            <div className="logout-modal-actions">
              <button className="cancel-btn" onClick={cancelLogout}>
                Cancel
              </button>
              <button className="confirm-logout-btn" onClick={confirmLogout}>
                Yes, Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default LmsMenu;
